import { create } from "zustand";
import { api } from "api";
import { usePersistentFetch } from "../utils/usePersistentFetch";
import { useCallback, useMemo } from "react";

const useStore = create((set) => ({
  indexTypes: [],
  isFetched: false,
  setIndexTypes: (indexTypes) => set({ indexTypes, isFetched: true }),
}));

const useIndexTypes = () => {
  const setIndexTypes = useStore((state) => state.setIndexTypes);
  const indexTypes = useStore((state) => state.indexTypes);
  const isFetched = useStore((state) => state.isFetched);

  const { fetchState } = usePersistentFetch({
    isFetched,
    setStoreData: setIndexTypes,
    fetchFn: api.satellite.fetchTypes,
    queryKey: "index-types",
  });

  const defaultIndex = useMemo(
    () => indexTypes?.[0]?.value || "",
    [indexTypes]
  );

  const getGradientOfIndexType = useCallback(
    (indexType) => {
      const foundIndex = indexTypes.find((type) => type.value === indexType);
      return foundIndex?.gradient || "";
    },
    [indexTypes]
  );

  const getRangeOfIndexType = useCallback(
    (indexType) => {
      const foundIndex = indexTypes.find((type) => type.value === indexType);
      return foundIndex?.range || "";
    },
    [indexTypes]
  );

  const getDescriptionOfIndexType = useCallback(
    (indexType) => {
      const foundIndex = indexTypes.find((type) => type.value === indexType);
      return foundIndex?.description || "";
    },
    [indexTypes]
  );

  return {
    indexTypes,
    fetchState,
    defaultIndex,
    getDescriptionOfIndexType,
    getGradientOfIndexType,
    getRangeOfIndexType,
  };
};

export { useIndexTypes };
